var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showInstallButton)?_c('app-header',{on:{"installApp":_vm.installApp}}):_vm._e(),_c('app-content'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }